// extracted by mini-css-extract-plugin
export default {"container":"SpotlightOverlay_container__2tF+R","content":"SpotlightOverlay_content__2gcgx","condensed":"SpotlightOverlay_condensed__U7bJP"};